import { atom } from "recoil";

export const playerRulesAutomaticLogStore = atom({
	key: "playerRulesAutomaticLogStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentSearch: "",
		currentSearchType: null,
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "id",
			},
			isDescending: true,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
